import styled from "styled-components";

export const PianoTuningDetailContainerStyled = styled.div`
  padding-bottom: 40px;
  .title_label {
    margin-bottom: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
  }
  .product_info_layout {
    margin-bottom: 12px;
    padding-left: 22px;
  }
  .booking_layout {
    margin-bottom: 16px;
    padding: 0 16px;
  }
  .btn_wrap {
    margin: auto;
    width: 100%;
    max-width: 167px;
  }

  .theme_standard {
  }
`;
